/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExpensesSentToPunchoutResource
 */
export interface ExpensesSentToPunchoutResource {
    /**
     * 
     * @type {string}
     * @memberof ExpensesSentToPunchoutResource
     */
    redirectionUrl: string;
}

/**
 * Check if a given object implements the ExpensesSentToPunchoutResource interface.
 */
export function instanceOfExpensesSentToPunchoutResource(value: object): value is ExpensesSentToPunchoutResource {
    if (!('redirectionUrl' in value) || value['redirectionUrl'] === undefined) return false;
    return true;
}

export function ExpensesSentToPunchoutResourceFromJSON(json: any): ExpensesSentToPunchoutResource {
    return ExpensesSentToPunchoutResourceFromJSONTyped(json, false);
}

export function ExpensesSentToPunchoutResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpensesSentToPunchoutResource {
    if (json == null) {
        return json;
    }
    return {
        
        'redirectionUrl': json['redirectionUrl'],
    };
}

export function ExpensesSentToPunchoutResourceToJSON(value?: ExpensesSentToPunchoutResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'redirectionUrl': value['redirectionUrl'],
    };
}

